import React, { useRef } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import api, { setAccessToken } from "../api/api";
import AuthLayout from "./AuthLayout";
import { useNavigate, Link } from "react-router-dom";
import { Carousel } from "react-bootstrap";
import Slider from "../components/Slider";


/* Google OAuth */
import { GoogleLogin } from "@react-oauth/google";

/* Microsoft OAuth */
import { useMsal } from "@azure/msal-react";


const RegisterSchema = Yup.object().shape({
  first_name: Yup.string().required("First name is required"),
  last_name: Yup.string().required("Last name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  password: Yup.string()
    .min(6, "Minimum 6 characters")
    .matches(/[A-Z]/, "At least one uppercase letter")
    .matches(/\d/, "At least one number")
    .matches(/[!@#$%^&*(),.?":{}|<>]/, "At least one special character")
    .required("Password is required"),
});

const Register = () => {
	const googleBtnRef = useRef(null);

  const navigate = useNavigate();
  const { instance } = useMsal();
  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      if (!values.accepted_terms) {
        toast.error("Please accept terms and conditions");
        setSubmitting(false);
        return;
      }
      const payload = {
		  email: values.email,
		  password: values.password,
		  first_name: values.first_name,
		  last_name: values.last_name,
      accepted_terms: values.accepted_terms,
		};

		await api.post("/auth/register", payload);

		toast.success("Registration successful! Verify OTP.");
		navigate("/verify-otp", { state: { email: values.email } });
			  
    } catch (err) {
      const msg = err?.response?.data?.error || "Registration failed";
      const lowerMsg = String(msg).toLowerCase();
      if (lowerMsg.includes("email is not verified")) {
        toast.info("Your account already exists and email verification is pending. Please log in to verify your email.");
        navigate("/login");
      } else if (lowerMsg.includes("already registered")) {
        toast.info("This email is already registered. Please log in to continue.");
        navigate("/login");
      } else {
        toast.error(msg);
      }
    } finally {
      setSubmitting(false);
    }
  };
/* =========================
     GOOGLE LOGIN
  ========================= */
  const handleGoogleLogin = async (credentialResponse) => {
    try {
      if (!credentialResponse?.credential) {
        toast.error("Google credential missing");
        return;
      }

      const res = await api.post("/oauth/google/login", {
        credential: credentialResponse.credential,
      });

      setAccessToken(res.data.token || res.data.access_token);

      toast.success("Google login successful");
      navigate("/dashboard", { replace: true });
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.error || "Google login failed");
    }
  };

  /* =========================
     MICROSOFT LOGIN
  ========================= */
  const handleMicrosoftLogin = async () => {
    try {
      const response = await instance.loginPopup({
        scopes: ["openid", "profile", "email"],
      });

      const res = await api.post("/oauth/microsoft/login", {
        id_token: response.idToken,
      });

      setAccessToken(res.data.token || res.data.access_token);

      toast.success("Microsoft login successful");
      navigate("/dashboard", { replace: true });
    } catch (err) {
      console.error("Microsoft login error:", err);
      toast.error("Microsoft login failed");
    }
  };
  return (
  <main className="login-screen">
    <div className="container">
      <div className="row align-items-center">
        
        <div className="col-md-6 order-2 order-md-1">
              <Slider className="login-slider">
            <Carousel.Item>
              <img src="images/slide1.png" className="img-fluid" />
              <Carousel.Caption>
                <h2>Join Us</h2>
                <p>Just go through the boring process of creating an account.</p>
              </Carousel.Caption>
            </Carousel.Item>

            <Carousel.Item>
              <img src="images/slide2.png" className="img-fluid" />
              <Carousel.Caption>
                <h2>Slide 2</h2>
                <p>Slide 2 subtext</p>
              </Carousel.Caption>
            </Carousel.Item>
          </Slider>
        </div>
        <div className="col-md-6 order-1 order-md-2 right-sec">
          <div className="logo-sec">
            <img src="images/logo.svg" className="logo" />
          </div>         

        <h1 className="title1">Create your account</h1>
        <div className="subtitle2">Unlock all Features!</div>

      <Formik
        initialValues={{
          first_name: "",
          last_name: "",
          email: "",
          password: "",
          accepted_terms: false,
        }}
        validationSchema={RegisterSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting, values, setFieldValue }) => (
          <Form className="mt-4">
          <div className="input-wrapper mb-2">
              <img src="/icons/user.svg" alt="email" className="input-icon left" />
              <Field name="first_name" className="form-control form_input" placeholder="First Name"/>
              
          </div> 
          <ErrorMessage name="first_name" component="small" className="text-danger mb-2 d-block" />
          <div className="input-wrapper mb-2">
              <img src="/icons/user.svg" alt="email" className="input-icon left" />
              <Field name="last_name" className="form-control form_input" placeholder="Last Name"/>
              
          </div> 
          <ErrorMessage name="last_name" component="small" className="text-danger mb-2 d-block" />
          <div className="input-wrapper mb-2">
              <img src="/icons/email.svg" alt="email" className="input-icon left" />
              <Field  name="email" type="email" className="form-control form_input" placeholder="Email"/>
              
          </div> 
          <ErrorMessage name="email" component="small" className="text-danger mb-2 d-block" />
          <div className="input-wrapper mb-2">
              <img src="/icons/shield.svg" alt="email" className="input-icon left" />
              <Field name="password" type="password" className="form-control form_input" placeholder="Password"/>
              
          </div>
          <ErrorMessage name="password" component="small" className="text-danger mb-2 d-block" />     
          <div className="options">
            <label className="custom-checkbox">
              <input
                type="checkbox"
                checked={values.accepted_terms}
                onChange={(e) => setFieldValue("accepted_terms", e.target.checked)}
              />
              <span className="checkmark"></span>
              Accept terms and conditions
            </label>
          </div>
           

            <button
              type="submit"
              className="btn-style1"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Creating..." : "Signup"}
            </button>

            <div className="footer-text">
              
                You have account? {" "}
                <Link to="/login">
                  Login now
                </Link>
              
            </div>
                <div className="divider">or Sign up with</div>
                <div className="social-buttons">
                        {/* Hidden Google Login Button */}
				<div style={{ display: "none" }}>
				  <GoogleLogin
					onSuccess={handleGoogleLogin}
					onError={() => toast.error("Google login failed")}
				  />
				</div>

				{/* Custom Google Button */}
				<button
				  type="button"
				  className="social-btn"
				  onClick={() => {
					const googleButton = document.querySelector('div[role="button"]');
					googleButton?.click();
				  }}
				>
				  <img src="icons/google.svg" alt="google" /> Google
				</button>

                        <button className="social-btn" onClick={handleMicrosoftLogin}>
                          <img src="icons/microsoft.svg" alt="microsoft"/> Microsoft
                        </button>
                    </div>
                
          </Form>
          
        )}
      </Formik>
      </div>
      </div>
    </div>

      </main>
  );
};

export default Register;
